import styles from '../scss/main.scss'
import WOW from 'wow.js'
import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

$(() => {
    var windowsize = $(window).width();

    var menu_action;
    if (windowsize < 768) {
        menu_action = 'click';
    }else {
        menu_action = 'mouseenter';
    }

    // menu
    var Menu = {
      el: {
        ham: $('.menu'),
        menuTop: $('.menu-top'),
        menuMiddle: $('.menu-middle'),
        menuBottom: $('.menu-bottom')
      },
      init: function() {
        Menu.bindUIactions();
      },
      bindUIactions: function() {
        Menu.el.ham
            .on(
              'click',
            function(event) {
            Menu.activateMenu(event);
            event.preventDefault();
          }
        );
      },
      activateMenu: function() {
        Menu.el.menuTop.toggleClass('menu-top-click');
        Menu.el.menuMiddle.toggleClass('menu-middle-click');
        Menu.el.menuBottom.toggleClass('menu-bottom-click');
      }
    };
    Menu.init();

    //menu
    //click anchor to scroll
    // $('.menu-list a').click(function(e) {
    //     if(this.hash && this.hash.length > 1){
    //
    //         // e.preventDefault();
    //         if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
    //             || location.hostname == this.hostname) {
    //
    //             var target = $(this.hash);
    //
    //             target = target.length ? target : $('[id=' + this.hash.slice(1) +']');
    //             if (target.length) {
    //                 $('html,body').animate({
    //                     scrollTop: target.offset().top
    //                 }, 1000);
    //                 return false;
    //             }
    //         }
    //     }
    // });

    $('.menu').on('click', function () {
      $('.main-navigation, .main-nav').toggleClass('open')
    })

    //menu bg toggle
    function toggleMenuBg() {
        if($(window).scrollTop() > 80 && !$('.main-nav').hasClass('dark')) {
            $('.main-nav').addClass('dark');
        }else if($(window).scrollTop() <= 80 && $('.main-nav').hasClass('dark')){
            $('.main-nav').removeClass('dark');
        }
    }
    $(window).scroll(function(){
        toggleMenuBg();
    });
    toggleMenuBg();

    // wow
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       true,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
        }
      }
    );
    wow.init();

    // moving bg Homepage
    function bgAnimation() {
      let crop = ($('.numbers').width() - $('.numbers .container').width()) / 2
      let bg_width = crop + $('.numbers .container').width()
      $('.numbers .bg').css('width', bg_width+'px')
    }

    if ($('.numbers').length) {
       bgAnimation()
    }


    // tabs

    $('.responsive-tabs__list__item').on('click', function () {
      let tab_number = $(this).attr('id').slice(-1)
      $('.services-img').each(function () {
        if ($(this).hasClass('img'+tab_number) && !$(this).hasClass('show')) {
          $('.services-img').removeClass('show')
          $(this).addClass('show')
        }
      })

    })

    //paralax
    window.addEventListener('scroll', function(event) {
      paralax(this)
    });
    function paralax(element) {
      var depth, i, layer, layers, len, movement, topDistance, translate3d;
      var el = element
      topDistance = el.pageYOffset / 8;

      layers = document.querySelectorAll("[data-type='parallax']");
      for (i = 0, len = layers.length; i < len; i++) {
        layer = layers[i];
        depth = layer.getAttribute('data-depth');

        topDistance = $(layer).offset().top - $(window).scrollTop()

        movement = (topDistance * depth);

        translate3d = 'translate3d(0, ' + movement + 'px, 0)';
        layer.style['-webkit-transform'] = translate3d;
        layer.style['-moz-transform'] = translate3d;
        layer.style['-ms-transform'] = translate3d;
        layer.style['-o-transform'] = translate3d;
        layer.style.transform = translate3d;
      }
    }

    paralax(window)

    // slider


    var mySwiper = new Swiper('.swiper-container', {
      // Optional parameters
      loop: true,
      slidesPerView: 2,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })

    // runnin numbers

    var numbers = [0,1, 2, 3, 4, 5, 6, 7];
    function generateNumber(index) {
      var desired = numbers[index];
      var duration = 1000;

      var output = $('#output' + index); // Start ID with letter
      console.log(output,'output')
      var started = new Date().getTime();
      let animationTimer;

      animationTimer = setInterval(function() {
        if (output.text().trim() === desired || new Date().getTime() - started > duration) {
          clearInterval(animationTimer); // Stop the loop
          output.text(desired); // Print desired number in case it stopped at a different one due to duration expiration
          generateNumber(index + 1);
        } else {
          output.text(
            '' +
            Math.floor(Math.random() * 10) +
            Math.floor(Math.random() * 10)
          );
        }
      }, 100);
    }
    generateNumber(1);

});



// WEBPACK FOOTER //
// ./src/js/main.js